import React, { type FC, type PropsWithChildren } from 'react';

import { Box, Collection, Container, Heading, Image, Text } from '@lucid/components';
import { withImage } from '@lucid/hooks';

import type { Lucid } from 'types/types';
import FlexiCta from '../flexi-cta/flexi-cta';

const FlexiHero: FC<PropsWithChildren<Lucid.Directus.Generated.Flexi_Hero>> = ({
  heading,
  text,
  image,
  show_default_cta,
  link_set,
}) => (
  <Box as="section">
    <Container
      css={theme => ({
        display: 'flex',
        alignItems: 'center',
        marginBottom: 0,
        [theme.breakpoints.bp768.min]: {
          marginBottom: theme.space.s80,
        },
        marginTop: theme.space.s40,
      })}
    >
      <Box
        css={theme => [
          {
            maxWidth: '100%',
            paddingBottom: theme.space.s40,
            [theme.breakpoints.bp1024.min]: {
              flexBasis: image ? '50%' : '100%',
            },
          },
        ]}
      >
        {heading && (
          <Heading as="h1" variant="hero3XL700">
            {heading}
          </Heading>
        )}
        {text && <Text variant="paragraphM300">{text}</Text>}
        {link_set && !!link_set?.length && (
          <Collection mx={5} my={5}>
            {link_set!.map((link, index) => {
              const { links_id } = link;

              return <FlexiCta key={`${links_id?.id}-${index + 1}`} displayAsButton data={links_id} />;
            })}
          </Collection>
        )}
        {show_default_cta && !link_set?.length && (
          <FlexiCta
            data={{
              id: 'default-link',
              final_url: '/contact/contact-sales',
              default_link_text: 'Contact sales',
              display_as_button: true,
            }}
          />
        )}
      </Box>
      {image && (
        <Box
          css={theme => ({
            display: 'none',
            padding: 0,
            flexBasis: '50%',
            [theme.breakpoints.bp768.min]: {
              display: 'block',
            },
          })}
        >
          <Image
            dataElementPageLocation="hero"
            imageAlt={image?.translations?.[0]?.alt || image.title}
            imageSrc={withImage(image)}
            loading="lazy"
          />
        </Box>
      )}
    </Container>
  </Box>
);

export default FlexiHero;
